import { useState } from "react";
import ChevronDownIcon from "../../../img/svg/chevronDownIcon";
import { IFAQ } from "../admin/faqs/adminFaqs";

export default function ExpandableFAQ({ faq, index }: { faq: IFAQ, index: number }) {

    const [expanded, setExpanded] = useState(false);

    return (
        <div 
            onClick={() => setExpanded(x => !x)} 
            className={`max-w-3xl mx-auto mb-4 overflow-hidden border transition-all duration-300 cursor-pointer group rounded-2xl ${
                expanded ? "bg-white border-primary shadow-xl shadow-primary/5" : "bg-moninho border-transparent hover:bg-white hover:border-surface"
            }`}
        >
            <div className="px-8 py-6 flex items-center justify-between gap-6">
                <div className="flex items-center gap-6">
                    <span className={`text-xs font-black transition-colors ${expanded ? "text-secondary" : "text-mono"}`}>
                        {(index + 1).toString().padStart(2, '0')}
                    </span>
                    <h3 className={`text-lg font-bold tracking-tight transition-colors ${expanded ? "text-primary " : "text-mono group-hover:text-primary"}`}>
                        {faq.question}
                    </h3>
                </div>
                <div className={`transition-transform duration-500 ${expanded ? "rotate-180 text-secondary" : "text-mono group-hover:text-primary"}`}>
                    <ChevronDownIcon width="20px" fill="currentColor" />
                </div>
            </div>
            
            <div 
                className={`transition-all duration-500 ease-in-out ${expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}
            >
                <div className="px-8 pb-8 pt-2 pl-20">
                    <p className="text-mono leading-relaxed text-lg border-l-2 border-secondary/20 pl-6">
                        {faq.answer}
                    </p>
                </div>
            </div>
        </div>
    )
}
